import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {HttpService} from "../http/HttpService";
import { KycStatus, ListUsersResponse, User, Product, UserLabel} from "../http/protocol";


export class UserService extends AbstractAdminEntityService<User, ListUsersResponse>   {
    

    constructor(http : HttpService) {
        super("/user", http)
    }

    setAttributes(userId:number,user:{ [index: string]: string }): Promise<User> {
        return this.http.post(this.entityPath + `/${userId}/attributes`, user);
    }

    setPokerId(userId:number): Promise<{}> {
        return this.http.get(this.entityPath + `/setPokerId/${userId}`);
    }

    setBlocked(userId:number): Promise<{}> {
        return this.http.get(this.entityPath + `/setBlocked/${userId}`);
    }
    
    getUserKycStatusCount(status:KycStatus): Promise<number> {
        return this.http.get(this.entityPath + `/kycCount/${status}`)
    }

    addUserLabel(userId:number, label:string):Promise<{}> {
        let encodedLabel= encodeURIComponent(label);
        return this.http.put(this.entityPath + `/${userId}/label/${encodedLabel}`, {});
    }

    deleteUserLabel(userId:number, label:string):Promise<{}> {
        let encodedLabel= encodeURIComponent(label);
        return this.http.delete(this.entityPath + `/${userId}/label/${encodedLabel}`);
    }

    getAllLabels():Promise<UserLabel[]> {
        return this.http.get('/userlabels/all');
    }


    createUserLabel(userLabel:UserLabel):Promise<UserLabel> {
        return this.http.post(this.entityPath + `/userlabels`, userLabel);
    }

    removeUserLabel(userLabelId:number):Promise<UserLabel> {
        return this.http.delete(this.entityPath + `/userlabels/${userLabelId}`);
    }

    disableUser2FA(userId:number | undefined):Promise<{}> {
        return this.http.delete(this.entityPath + `/${userId}/mfa`);
    }

    updateProductEnabled(userId: number | undefined, product: Product, enable: boolean): Promise<{}> {
        let url = `/user/${userId}/${product}`;
        return this.http.post(url, enable);
    }

}